import {h, Fragment} from "preact"
import { defaultConfig } from "../config"
import { useAppState, HistoryElement } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks"

export default function History() {
    const { historyItems } = useAppState();
    const [showOverlay, setShowOverlay] = useState(false);
    const popSearches = ['halloween', 'fall favorites', 'football', 'dogs', 'cats', 'christmas', 'grinch', 'sports & hobbies', 'boxy tees', 'national parks']
    let topOffset = 0

    const headerElements = document.querySelectorAll('.shopify-section-group-header-group')
    headerElements.forEach(element => {topOffset += element.offsetHeight} )

    if(window.innerWidth > 1023){
        topOffset = 124
    }

    document.addEventListener("click", function(event) { 
        if(!event.target.closest('.nosto-autocomplete-wrapper')) {
            handleOverlayClick()  
        }      
      });

    useEffect(() => {
        const inputField = document.querySelector("input#search-input");
        if (inputField) {
            inputField.addEventListener("focus", handleInputFocus);
            inputField.addEventListener("click", handleInputFocus);
            inputField.click();
        }
    }, []);

    const handleInputFocus = (event) => {
        if (event.target.value.trim() === "") {
            setShowOverlay(true);
            // document.body.style.overflow = 'hidden'; 
            document.body.classList.add('ns-block-scroll')
        }
    };

    const handleOverlayClick = () => {
        setShowOverlay(false); 
        // document.body.style.overflow = 'auto'; 
        document.body.classList.remove('ns-block-scroll')
    };

    // if (!historyItems || !historyItems.length) {
    //     return
    // }

    useEffect(() => {
        nostojs(api => api
            .createRecommendationRequest({ includeTagging: true })
            .setElements(['searchdropdown-nosto-1'])
            .loadRecommendations({ skipPageViews: true }).then(() => {
                document.querySelector("#searchdropdown-nosto-1 .close-btn")?.addEventListener("click", () => {
                    document.querySelector(".nosto-autocomplete-wrapper .nosto-autocomplete-wrapper > div").style.display = "none";
                    handleOverlayClick();
                })
            }));
    }, []);

    return (
        <>
            <div class="ns-autocomplete ns-history-container ns-autocomplete-container" style={`top: ${topOffset - 20}px`}>
                <div class="ns-autocomplete-inner">
                    <span class="ns-close-btn close-btn h5" onClick={() => {
                        document.querySelector(".nosto-autocomplete-wrapper .nosto-autocomplete-wrapper > div").style.display = "none";
                        handleOverlayClick();
                    }}>X</span>
                    <div class="ns-autocomplete-alignment">
                        <div class="ns-keywords-container">
                            <div class="ns-ac-text h5">Search Suggestions</div>
                            {popSearches &&
                                <div class="ns-keywords-inner">
                                    {popSearches?.map(searchItem => {
                                        return(
                                        <div 
                                            class="ns-autocomplete-element ns-clickable ns-py-2 ns-px-4 ns-font-4"
                                            data-nosto-query={searchItem}
                                            onClick={(e) => {
                                                window.location.href = `/search?q=${searchItem.replaceAll(" ", "+")}`
                                            }}
                                        >
                                            <span data-nosto-element="keyword">{searchItem}</span>
                                        </div>)
                                    })}
                                </div>
                            }
                        </div>
                        <div class="ns-ac-products-container">
                            <div class="nosto_element" id="searchdropdown-nosto-1" ></div>
                        </div>
                    </div>
                </div>
            </div>
            {showOverlay && (
                <div class="ns-dark-overlay-history" onClick={handleOverlayClick}></div>
            )}
        </>
    )
}
